import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  DxButtonModule,
  DxCheckBoxModule,
  DxDateBoxModule,
  DxDropDownBoxModule,
  DxListModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxTooltipModule,
} from 'devextreme-angular';

import { AuthenticationModalComponent } from './components/authentication-modal/authentication-modal.component';
import { EmailConfirmationComponent } from './components/email-confirmation/email-confirmation.component';
import { ExternalSsoComponent } from './components/external-sso/external-sso.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginSelectionComponent } from './components/login-selection/login-selection.component';
import { LoginComponent } from './components/login/login.component';
import { OneTimeCodeLoginComponent } from './components/one-time-code-login/one-time-code-login.component';

@NgModule({
  declarations: [
    ForgotPasswordComponent,
    LoginComponent,
    EmailConfirmationComponent,
    OneTimeCodeLoginComponent,
    AuthenticationModalComponent,
    LoginSelectionComponent,
    ExternalSsoComponent,
  ],
  imports: [
    DxTextBoxModule,
    DxDateBoxModule,
    DxButtonModule,
    DxTooltipModule,
    DxListModule,
    DxDropDownBoxModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxTextAreaModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  exports: [AuthenticationModalComponent],
})
export class CoreAuthenticationModule {}
